import { FC } from 'react';
import { AddressType } from '../types';
import styles from './formats.module.scss';
interface EastAsiaFormatAddressProps {
  isFullAddress?: boolean;
  address: AddressType;
  isAddressTypeDisplay?: boolean;
  translatedAddressType?: string;
  isAsianOrder?: boolean;
  translatedPostalSymbol?: string;
}

export const EastAsiaFormatAddress: FC<EastAsiaFormatAddressProps> = ({
  isFullAddress,
  address,
  isAddressTypeDisplay,
  translatedAddressType,
  isAsianOrder,
  translatedPostalSymbol
}) => {
  const {
    address1,
    address2,
    city,
    country,
    email,
    firstName,
    lastName,
    phone,
    state,
    zipCode
  } = address;

  const eaSpacingForFirstName = lastName && firstName ? ' ' : '';
  const eaStateSpacing = state && city ? ' ' : '';
  const eaCountryAndZipCodeSpacing = country && zipCode ? ' ' : '';
  const eaStateAndZipCodeSpacing = (state || city) && zipCode ? ' ' : '';

  return (
    <div data-testid="address-east-asia" className={styles['formats']}>
      {isAddressTypeDisplay && (
        <p className="cat-u-theme-typography-label mb-0" data-cs-encrypt>
          {translatedAddressType}
        </p>
      )}
      {(firstName || lastName) && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {lastName}
          {eaSpacingForFirstName}
          {firstName}
        </p>
      )}
      {!isAsianOrder && (country || zipCode) && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {country}
          {eaCountryAndZipCodeSpacing}
          {zipCode}
        </p>
      )}
      {!isAsianOrder && (state || city) && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {state}
          {eaStateSpacing}
          {city}
        </p>
      )}
      {isAsianOrder && (zipCode || city || state) && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {zipCode && translatedPostalSymbol}
          {zipCode}
          {eaStateAndZipCodeSpacing}
          {state}
          {eaStateSpacing}
          {city}
        </p>
      )}
      {address1 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address1}
        </p>
      )}
      {address2 && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {address2}
        </p>
      )}
      {isAsianOrder && country && (
        <p className="mb-0 exclude-global text-capitalize" data-cs-encrypt>
          {country}
        </p>
      )}
      {phone && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {phone}
        </p>
      )}
      {email && isFullAddress && (
        <p className="mb-0 exclude-global" data-cs-encrypt>
          {email}
        </p>
      )}
    </div>
  );
};
